import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Badge, Th, Td, Empty, fmtDate } from "./ui";

export default function Messages() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/messages").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Berichten" subtitle="E-mail & WhatsApp (testmodus — berichten worden gelogd, niet echt verstuurd)" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Kanaal</Th><Th>Template</Th><Th>Ontvanger</Th><Th>Onderwerp</Th><Th>Status</Th><Th>Datum</Th></tr></thead>
            <tbody>
              {rows.map((m) => (
                <tr key={m.id} className="border-b border-white/5" data-testid={`message-row-${m.id}`}>
                  <Td>{m.channel === "email" ? "E-mail" : "WhatsApp"}</Td>
                  <Td className="text-white/60">{m.template}</Td>
                  <Td>{m.recipient}</Td>
                  <Td className="max-w-[220px] truncate text-white/60">{m.subject || m.body}</Td>
                  <Td><Badge status={m.status} /></Td>
                  <Td className="text-white/50">{fmtDate(m.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Nog geen berichten" />}
        </div>
      </Card>
    </div>
  );
}
